import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Phone = (props) => {
  const { label, placeholder, handleChange, value, phoneWd, loading , inputClass="" } = props;

  return (
    <div className={phoneWd}>
      {label && (
        <label htmlFor="" className="Input_label">
          {label}
        </label>
      )}
      {loading ? (
        <Skeleton height={40} baseColor="#e0e0e0" highlightColor="#ECE7FD" />
      ) : (
        <PhoneInput
          country={"ca"}
          value={value}
          enableSearch={true}
          placeholder={placeholder}
          onChange={(phone) => handleChange(phone)}
          inputClass={`Input_phone ${inputClass}`}
          autoFormat
          buttonClass="border-0"
          autocomplete="new-tel"

        />
      )}
    </div>
  );
};

export default Phone;
